import { useLingui } from '@lingui/react/macro';
import { endOfDay, parseISO } from 'date-fns';
import { isBefore } from 'date-fns/isBefore';

import Toggle from '@/design_system/Toggle';
import { useUpdateArticle } from '@/models/article';

import { useArticleContext } from '../../contexts/ArticleContext';

export const WarrantyDistributorExtensionToggle = () => {
  const { t } = useLingui();
  const { request, article } = useArticleContext();

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  const isDistributorWarrantyExtensionPotentiallyApplicable =
    !!article.distributorWarrantyExpirationDate &&
    !isBefore(
      endOfDay(parseISO(article.distributorWarrantyExpirationDate)),
      new Date(request.referencedAt ?? request.createdAt)
    );

  if (!isDistributorWarrantyExtensionPotentiallyApplicable) {
    return null;
  }

  return (
    <Toggle
      alignment="left"
      isSelected={article.hasDistributorWarrantyExtension}
      onChange={(value) => {
        updateArticle({ data: { hasDistributorWarrantyExtension: value } });
      }}
      label={t({
        id: 'article.form.warranty-distributor-extension-toggle.label',
        message: 'The client has a warranty extension',
      })}
    />
  );
};
